import React from 'react';
import _ from 'lodash';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import { IconButton } from 'material-ui';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { updateCargoOrder } from 'actions/cargoes/orders';
import CollapseCustomizable from '../../../../../common/CollapseCustomizable';
import helpers from 'helpers';

const styles = {
    tableRow: {
        width: '85px', 
        padding: '15px', 
        whiteSpace: 'pre-wrap',
        textAlign: 'center', 
        verticalAlign: 'middle',
        fontSize: '13px',
    },
    tableRowMain: {
        width: '120px', 
        padding: '0', 
        wordWrap: 'break-word',
        textAlign: 'center', 
        verticalAlign: 'middle',
        fontSize: '13px',
    },
    tableRowFixedColumn: {
        width: '65px', 
        whiteSpace: 'pre-wrap',
        textAlign: 'center', 
        verticalAlign: 'middle',
        margin: '30px',
        background: '#FFFFFF',
    },
};

function defaultPackingList() {
    return {
        name: '',
        weight: undefined,
        weightIsCalc: undefined,
        length: undefined,
        width: undefined,
        height: undefined,
        quantity: undefined,
        totalWeight: undefined,
        imdg: undefined,
        grossWeight: undefined,
        netWeight: undefined,
        tareWeight: undefined,
        area: undefined,
        areaIsCalc: undefined,
        volume: undefined,
        volumeIsCalc: undefined,
    };
}

const PACKING_FIELDS = [
    'length', 'width', 'height', 'quantity', 'weight', 'totalWeight', 'volume', 
    'area', 'imdg', 'grossWeight', 'netWeight', 'taraWeight',
];

class PackingList extends React.Component {
    constructor(props) {
        super(props);

        this.addRow = this.addRow.bind(this);
        this.removeRow = this.removeRow.bind(this);
        this.changeValue = this.changeValue.bind(this);
    }

    addRow() {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo[this.props.cargoPackingIndex].packingList.push(defaultPackingList());
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    removeRow(index) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.cargo[this.props.cargoPackingIndex].packingList.splice(index, 1);
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    changeValue(e, index, field) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        const { packing, packingList } = newCargoOrder.cargo[this.props.cargoPackingIndex];

        let { value } = e.target;

        if (field !== 'name') {
            value = helpers.clearLetters(e.target.value);

            value = value || undefined;
        }

        packingList[index][field] = value;

        if (['quantity', 'weight'].includes(field)) {
            const opposite = field === 'quantity' ? 'weight' : 'quantity';

            if (packingList[index].weight || packingList[index].quantity) {
                packingList[index].totalWeight = e.target.value * packingList[index][opposite];
            
                if (packing.pack.unitsWeight[0].isCalc) {
                    packing.pack.unitsWeight[0].value = packingList.reduce((acc, item) => {
                        if (item.totalWeight) {
                            return acc + item.totalWeight;
                        } 
                        return acc + 0;
                    }, 0);
                }

                if (packing.pack.unitsQuantityIsCalc) {
                    packing.pack.unitsQuantity = packingList.reduce((acc, item) => acc + parseInt(item.quantity), 0);
                }

                if (newCargoOrder.totalValues.isCalc) {
                    newCargoOrder.totalValues.weight = newCargoOrder.cargo
                        .reduce((acc, item) => acc + item.packingList.reduce((acc, item) => acc + item.totalWeight, 0), 0) * 1000;

                    newCargoOrder.totalValues.weightWithPercent = parseInt(newCargoOrder.cargo.reduce((acc, item) => {
                        const { deviation } = item.packing.pack.unitsWeight[0];
                        const sumValue = item.packingList.reduce((acc, item) => acc + item.totalWeight, 0);
                        if (deviation && sumValue) {
                            return acc + sumValue * ((deviation / 100) + 1);
                        } else if (!deviation && sumValue) {
                            return acc + sumValue;
                        } 
                        return acc + 0;
                    }, 0) * 1000);
                }
            }
        }

        if (field === 'volume') {
            if (packing.pack.unitsVolume[0].isCalc) {
                packing.pack.unitsVolume[0].value = packingList.reduce((acc, item) => { 
                    if (item.volume) {
                        return acc + parseInt(item.volume);
                    } 
                    return acc + 0;
                }, 0);
            }

            if (newCargoOrder.totalValues.isCalc) {
                newCargoOrder.totalValues.volume = newCargoOrder.cargo
                    .reduce((acc, item) => acc + item.packingList.reduce((acc, item) => acc + parseInt(item.volume), 0), 0);

                newCargoOrder.totalValues.volumeWithPercent = parseInt(newCargoOrder.cargo.reduce((acc, item) => {
                    const uv = item.packing.pack.unitsVolume[0];
                    const sumValue = item.packingList.reduce((acc, item) => acc + item.volume, 0);
                    if (uv.deviation && sumValue) {
                        return acc + sumValue * ((uv.deviation / 100) + 1);
                    } else if (!uv.deviation && sumValue) {
                        return acc + sumValue;
                    } 
                    return acc + 0;
                }, 0));
            }
        }
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    render() {
        const { packingList } = this.props.cargoOrder.cargo[this.props.cargoPackingIndex];
        return (<React.Fragment>
            <CollapseCustomizable 
                _key='packingList'
                bodyStyle={{
                    borderBottom: '1px solid #E0E0E0',
                }}
                head={
                    <React.Fragment>
                        <span style={{ fontSize: '16px', lineHeight: '22px' }}>PACKING LIST</span>
                    </React.Fragment>
                }
                body={
                    <React.Fragment>
                        <Table
                            bodyStyle={{ overflow: 'visible' }}
                            headerStyle={{ width: 'auto' }}
                        >
                            <TableHeader
                                displaySelectAll={false}
                                enableSelectAll={false}
                                adjustForCheckbox={false}
                            >
                                <TableRow>
                                    <TableHeaderColumn style={styles.tableRowMain}>Name</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>L, m</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>B, m</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>H, m</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>Qty</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>Weight, mt</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>TTL weight, mt</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>Volume, m3</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>Area, m2</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>IMDG</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>Gross Weight, mt</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>Net Weight, mt</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow}>Tare Weight, mt</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.tableRow} />
                                </TableRow>
                            </TableHeader>
                            <TableBody
                                displayRowCheckbox={false}
                            >
                                { packingList.map((packItem, packIndex) => (
                                    <TableRow
                                        key={`${packItem.name}_${packIndex}`}
                                        displayBorder
                                        selectable={false}
                                        style={{ fontSize: '14px' }}
                                    >
                                        <TableRowColumn style={styles.tableRowMain}>
                                            <TextField
                                                name='name'
                                                value={packItem.name}
                                                type='text'
                                                min={0}
                                                style={{ width: '5em', fontSize: '14px' }}
                                                onChange={e => this.changeValue(e, packIndex, 'name')}
                                            />
                                        </TableRowColumn>
                                        { PACKING_FIELDS.map((field, index) => (<TableRowColumn 
                                            key={`${field}_${index}`}
                                            style={styles.tableRow}
                                        >
                                            <TextField
                                                name={field}
                                                value={packItem[field] || ''}
                                                type='number'
                                                min={0}
                                                style={{ width: '3em', fontSize: '14px' }}
                                                onChange={e => this.changeValue(e, packIndex, field)}
                                            />
                                        </TableRowColumn>)) }
                                        <TableRowColumn style={styles.tableRowFixedColumn}>
                                            <IconButton >
                                                { packIndex !== packingList.length - 1 ?
                                                    <ContentRemoveIcon
                                                        color='red'
                                                        onClick={() => this.removeRow(packIndex)}
                                                    />
                                                    :
                                                    <ContentAddIcon
                                                        color='green'
                                                        onClick={() => this.addRow()}
                                                    /> }
                                            </IconButton>
                                        </TableRowColumn>
                                    </TableRow>
                                )) }
                            </TableBody>
                        </Table>
                    </React.Fragment>
                }
            />
        </React.Fragment>);
    }
}


export default connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];

        return {
            numberOrderTable: ownProps.numberOrderTable,
            cargoOrder,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(PackingList);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/PackingList.jsx